<template>
  <div class="trainer-streak trasrtgk csst csst_nm">
    <div
      class="trarng_icon_cont"
      :class="{ trasrtgk_icon_cont_roll: animate }"
    >
      <LottieAnimation
        ref="fire"
        :animationData="animationData"
        :autoPlay="false"
        :class="status"
        :loop="true"
        :speed="1"
        class="trasrtgk_fire trasrtgk_icon streak-svg-no-transform"
      />
    </div>
    <span
      class="trasrtgk_value"
      :class="{ trasrtgk_value_visible: numVisible }"
    >
      <!-- {{ moves || 0 }} -->
      {{ streak.moves || 0 }}
    </span>
    <div
      class="csst_content clr-white text-nowrap"
      style="position: fixed; margin-top: 2.5rem"
    >
      {{ $t(`tooltips.${status}_streak`) }}
    </div>
  </div>
</template>

<script>
// https://www.npmjs.com/package/lottie-web-vue?activeTab=readme
import { LottieAnimation } from 'lottie-web-vue'
import animationData from '@/assets/lottieJSONs/fire.json'

export default /** @type {any} */ {
  name: 'TrainerStreak',
  components: {
    LottieAnimation,
  },
  props: {
    streak: Object,
  },
  data() {
    return {
      animDuration: 220,
      animate: false,
      numVisible: true,
      l_streak: null,
      playing: false,
      animationData,
    }
  },
  // mounted() {
  // this.setStreak(this.streak)
  // },
  methods: {
    setStreak(val) {
      if (this.l_streak?.moves >= val?.moves) {
        this.numVisible = false
      }
      if (val) {
        this.l_streak = { ...val, moves: this.l_streak?.moves }
        this.animate = true
        setTimeout(() => {
          this.animate = false
          this.numVisible = true
          this.l_streak = val
        }, this.animDuration)
      }
      this.playPause()
      // this.$refs.fire.play()
      // this.playing = true
    },
    playPause() {
      if (!this.$refs.fire) return
      if (this.l_streak?.status === 'win') {
        if (this.playing) return
        if (this.l_streak?.moves < 2) return

        this.$refs.fire.play()
        this.playing = true
      } else if (this.playing) {
        this.$refs.fire.pause()
        this.playing = false
      }
    },
  },
  computed: {
    status() {
      return this.l_streak?.status
    },
  },
  watch: {
    streak: {
      immediate: true,
      handler: 'setStreak',
    },
  },
}
</script>
<style lang="scss">
.trasrtgk_fire {
  svg {
    path {
      fill: currentColor;
      &:nth-child(2) {
        stroke: transparent;
      }
    }
  }
}
</style>
<style lang="scss">
.streak-svg-no-transform {
  svg {
    transform: none !important;
  }
}
</style>
<style lang="scss" scoped>
.trasrtgk {
  border-radius: 8px;
  line-height: 1;
  flex: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--clr-grey-2);
  max-height: 1.25rem;
  &_fire {
    width: 1.75rem;
  }
  &_icon {
    position: relative;
    font-size: 1.5rem;
    --anim-duration: 220ms;
    color: var(--clr-grey-2);

    &.neutral {
      color: var(--clr-grey-2);
    }
    &.loss {
      color: var(--clr-losing-streak);
    }
    &.win {
      color: var(--clr-winning-streak);
    }
    &_cont {
      position: relative;
      transition: transform var(--anim-duration);
      display: flex;
    }
  }
  &_value {
    font-weight: 500;
    font-size: 0.875rem;
    padding-left: 0.325rem;
    font-weight: 700;
    position: relative;
    left: -1.5rem;
    opacity: 0;
    transition: 0.15s;
    &_visible {
      left: -0.25rem;
      opacity: 1;
    }
  }
}
</style>
